import { render, staticRenderFns } from "./DashboardStats.vue?vue&type=template&id=0ff2f813"
import script from "./DashboardStats.vue?vue&type=script&lang=js"
export * from "./DashboardStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports